import { PermissionsEnum } from "@/auth/interfaces";
import { ROUTER_PATHS, useCheckPermissionsArray } from "@/shared";
import SaveInventariable from "../../componente/SaveInventarible";
import { useFetchProductoSimple } from "@/shared/actions/erp";
import { Navigate, useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import { toast } from "react-toastify";

export default function UpdateInventarioPage() {


  const { idproducto } = useParams();

  useCheckPermissionsArray([
    PermissionsEnum.api_view_producto,
    PermissionsEnum.api_change_producto
  ]);

  const {
    data: dataProductoById,
    isLoading: isLoadingDataProductoById
    //} = useFetchProductoById(idproducto!, true);
  } = useFetchProductoSimple({
    params: {
      id_producto: idproducto
    }
  });

  if (isLoadingDataProductoById) {
    return <LoaderComponent />
  }

  if (dataProductoById?.data.count == 0) {
    toast.info('Producto no encontrado. [404]')
    return <Navigate to={ROUTER_PATHS.inventario.productosNav} />
  }

  return (
    <SaveInventariable
      titlePage="Editar Producto"
      editInventario={dataProductoById?.data.data[0]}
    />
  )

}